import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { Modals } from './components/Modal.tsx';
import { Toasts } from './components/Toast.tsx';

//token auto-refresh logic is here. 
//call /token/refresh endpoint to refresh the token every 5 mins

const refreshToken = () => {
  fetch('/auth/refresh', {
    method: 'POST',
    credentials: 'include',
  })
  .then(response => {
    if (!response.ok) {
      console.error('Failed to refresh token');
    }
  })
  .catch(error => {
    console.error('Error refreshing token:', error);
  });
}

setInterval(refreshToken, 5 * 60 * 1000); // Refresh every 5 minutes

//also refresh token on page load (content visibility change event or newver api)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    refreshToken();
  }
});

let initialHeight = document.body.clientHeight;
let initialWidth = document.body.clientWidth;

function isKeyboardOpen(threshold = 150) {
  const heightDiff = initialHeight - document.body.clientHeight;
  const widthDiff = Math.abs(initialWidth - document.body.clientWidth);

  if (widthDiff > 100) {
    // Phone rotated → reset baseline
    initialHeight = document.body.clientHeight;
    initialWidth = document.body.clientWidth;
    return;
  }

  return heightDiff > threshold;
}

var ts = 0;
document.body.addEventListener('touchstart', function (e){
   ts = e.touches[0].clientY;
});

document.body.addEventListener('touchmove', (e) => {
  const target = e.target;

  if (!isKeyboardOpen()){
    return;
  }
  var te = e.changedTouches[0].clientY;
  var isUp = ts > te;

  // Allow scrolling if the target or its parents can scroll
  let el = target as HTMLElement | null;
  while (el && el !== document.body) {
    const style = window.getComputedStyle(el);
    const isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX);
    if (isScrollable) {
      const canScrollUp = el.scrollTop < el.scrollHeight - el.clientHeight;
      const canScrollDown = el.scrollTop > 0;
      if (canScrollUp && isUp) {
        return; // Don't block scrolling on this element
      }
      if (!isUp && canScrollDown) {
        return; // Don't block scrolling down if already scrolled
      }
    }
    el = el.parentElement;
  }

  // If no scrollable parent found, prevent scrolling
  e.preventDefault();
}, { passive: false });

createRoot(document.getElementById('app')!).render(  
  <>
    <App />
    <Modals />
    <Toasts />
  </>,
)
